import * as React from 'react';
import { IAsidePanelTabsProps } from './types';
import './_AsidePanelTabs.scss';
import { CLASS_ASIDE_PANEL_TABS } from './constants';
import { Tabs, Button, Icon } from 'kui';
import { NewFeatureIndicator } from '../../../../base/components/NewFeatureIndicator/NewFeatureIndicator';
import { ProFeatureIndicator } from '../../../../base/components/ProFeatureIndicator/ProFeatureIndicator';
import { AsidePanelContext } from '../AsidePanel/constants';
import { AnalyzeRender } from '../../../../helpers/memoizeHelper';
import { root } from '../../../../../../store/constants';
// @ts-ignore
const analyzeRender = window.Settings.development ? new AnalyzeRender(`AsidePanelTabs`) : null;

export function AsidePanelTabs ({
    activeTabIndex,
    asidePanelWidth,
    navigationPanelWidth,
    tabs,
    onChange,
    onClick,
    showHint
}: IAsidePanelTabsProps) {
    if (analyzeRender) analyzeRender.call(activeTabIndex);
    const { cardId, isMobile } = React.useContext(AsidePanelContext);
    const classTab = CLASS_ASIDE_PANEL_TABS + '-item';
    React.useEffect(() => {
        const onScroll = () => {
            const card = document.querySelector(`[data-rbd-draggable-id="${cardId}"]`) as HTMLElement;
            if (card) {
                const rect = card.getBoundingClientRect();
                const asidePanelRight = root._innerWidth - asidePanelWidth;
                if (navigationPanelWidth > rect.right || asidePanelRight < rect.left) {
                    showHint(true);
                } else {
                    showHint(false);
                }
            }
        }
        document.addEventListener('scroll', onScroll)
        return () => {
            document.removeEventListener('scroll', onScroll);
        }
    },[asidePanelWidth, navigationPanelWidth])
    return (
        <Tabs
            className={CLASS_ASIDE_PANEL_TABS}
            active={activeTabIndex}
            onChange={newIdx => onChange(newIdx, activeTabIndex, cardId)}
        >
            {tabs.map(tab => (
                <Button
                    key={tab.key}
                    onClick={() => onClick(tab.onClick)}
                    className={`
                        ${classTab}
                        ${classTab}--${tab.name.toLowerCase().replace(' ', '')}
                    `}
                >
                    {tab.name}
                    {tab.icon &&
                        <Icon
                            size={24}
                            xlink={tab.icon}
                        />
                    }
                    {
                        tab.indicatorNumber
                            ? <span className={CLASS_ASIDE_PANEL_TABS + '-indicator-number'}>{tab.indicatorNumber}</span>
                            : null
                    }
                    {tab.isNewFeature && <NewFeatureIndicator />}
                    {tab.isProFeature && <ProFeatureIndicator />}
                    {tab.hint && tab.hint(`.${classTab}--${tab.name.toLowerCase().replace(' ', '')}`)}
                </Button>
            ))}
        </Tabs>
    );
};
